import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { getTranslation } from './translations';
import LanguageSelector from './LanguageSelector';

function Login({ onLogin }) {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const response = await fetch('/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          username: email,
          password: password,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        sessionStorage.setItem('access_token', data.access_token);
        setMessage(getTranslation('loginSuccessful', language));
        setEmail('');
        setPassword('');
        if (onLogin) onLogin();
        navigate('/');
      } else {
        let errorMsg = getTranslation('loginFailed', language);
        if (data.detail) {
          if (Array.isArray(data.detail)) {
            errorMsg = data.detail.map(err => err.msg).join(' ');
          } else if (typeof data.detail === 'string') {
            errorMsg = data.detail;
          }
        }
        setMessage(errorMsg);
      }
    } catch (error) {
      setMessage(getTranslation('serverError', language));
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f8ff',
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: window.innerWidth <= 600 ? '20px 20px' : '40px 0',
      fontFamily: 'Nunito, Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Language Selector - Top Right */}
      <div style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1000
      }}>
        <LanguageSelector />
      </div>
      
      {/* Main Title */}
      <h1 style={{
        fontSize: window.innerWidth <= 600 ? '2.5rem' : '3.5rem',
        fontWeight: 'bold',
        color: '#7c3aed',
        margin: '0 0 16px 0',
        textAlign: 'center',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
        {getTranslation('shootMe', language)}
      </h1>
      
      {/* Subtitle */}
      <p style={{
        fontSize: window.innerWidth <= 600 ? '1rem' : '1.2rem',
        color: '#6b7280',
        margin: '0 0 48px 0',
        textAlign: 'center',
        maxWidth: window.innerWidth <= 600 ? '90%' : '600px',
        lineHeight: '1.6',
        padding: window.innerWidth <= 600 ? '0 20px' : '0'
      }}>
{getTranslation('appDescription', language)}
      </p>

      <div style={{
        background: 'white',
        borderRadius: window.innerWidth <= 600 ? 16 : 20,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
        maxWidth: window.innerWidth <= 600 ? '95%' : 400,
        width: window.innerWidth <= 600 ? '95%' : 400,
        padding: window.innerWidth <= 600 ? 24 : 32,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}>
        <h2 style={{ 
          color: '#7c3aed', 
          marginBottom: 24, 
          fontFamily: 'Nunito, Arial, sans-serif', 
          fontWeight: 700, 
          letterSpacing: 1,
          fontSize: window.innerWidth <= 600 ? '1.5rem' : '1.8rem',
          textAlign: 'center'
        }}>{getTranslation('login', language)}</h2>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: window.innerWidth <= 600 ? 16 : 18 }}>
            <label style={{ 
              color: '#4b4b4b', 
              fontWeight: 500,
              fontSize: window.innerWidth <= 600 ? '14px' : '16px'
            }}>{getTranslation('email', language)}:</label><br />
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ 
                width: '100%', 
                padding: window.innerWidth <= 600 ? 12 : 10, 
                borderRadius: 8, 
                border: '1px solid #bdbdbd', 
                marginTop: 4, 
                fontSize: window.innerWidth <= 600 ? '16px' : '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>
          <div style={{ marginBottom: window.innerWidth <= 600 ? 16 : 18 }}>
            <label style={{ 
              color: '#4b4b4b', 
              fontWeight: '500',
              fontSize: window.innerWidth <= 600 ? '14px' : '16px'
            }}>{getTranslation('password', language)}:</label><br />
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{ 
                width: '100%', 
                padding: window.innerWidth <= 600 ? 12 : 10, 
                borderRadius: 8, 
                border: '1px solid #bdbdbd', 
                marginTop: 4, 
                fontSize: window.innerWidth <= 600 ? '16px' : '16px',
                boxSizing: 'border-box'
              }}
            />
          </div>
          <button type="submit" style={{
            width: '100%',
            padding: window.innerWidth <= 600 ? '14px 0' : '12px 0',
            borderRadius: 8,
            border: 'none',
            background: '#7c3aed',
            color: 'white',
            fontWeight: 700,
            fontSize: window.innerWidth <= 600 ? '16px' : '18px',
            letterSpacing: 1,
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            marginBottom: 8
          }}>{getTranslation('loginButton', language)}</button>
        </form>
        <div style={{ 
          textAlign: 'center', 
          marginTop: 16,
          fontSize: window.innerWidth <= 600 ? '14px' : '16px'
        }}>
          <button 
            type="button"
            onClick={() => navigate('/forgot-password')}
            style={{
              background: 'none',
              border: 'none',
              color: '#7c3aed',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: 'inherit',
              fontFamily: 'inherit'
            }}
          >
            {getTranslation('forgotPassword', language)}
          </button>
        </div>
        {message && <div style={{ 
          marginTop: 18, 
          color: message.includes('success') ? '#2e7d32' : '#c62828', 
          fontWeight: 500,
          fontSize: window.innerWidth <= 600 ? '14px' : '16px',
          textAlign: 'center',
          padding: window.innerWidth <= 600 ? '0 10px' : '0'
        }}>{message}</div>}
      </div>
    </div>
  );
}

export default Login; 
